import { Parameter } from "../types/Parameter";
import evaluate, { registerFunction } from "ts-expression-evaluator";

export const convertParamerType = (param: Parameter): Parameter => {
  if (param.type.startsWith("System.Int32")) {
    param.type = "number";
  } else if (param.type.startsWith("System.String")) {
    param.type = "string";
  } else if (param.type.startsWith("System.DateTime")) {
    param.type = "dateTime";
  } else if (param.type.startsWith("System.Boolean")) {
    param.type = "boolean";
  }
  return param;
};

export const updateMaxValues = (params: Parameter[]): Parameter[] => {
  const parameters = [...params];
  const context: {
    [key: string]: any;
  } = {};

  parameters.forEach(
    (p, index) =>
      (context[p.name.replace(".", "_")] = p?.value)
  );

  parameters.forEach((parameter) => {
    if (parameter.maxExpression) {
      parameter.maxValue = evaluate(parameter.maxExpression, context);
    }
  });

  return parameters;
};
